export default {
    rateChallenge: {
        title: 'Thank you for taking the time to chill.',
        description: 'How would you rate your experience?',
        footerText: 'We value your feedback.',
        buttonText: 'OK',
        successMessage: 'Thank you for your feedback!',
        errorMessage: 'Please rate your experience'
    }
};
